import type { GenerationStatus } from '../model/session.types';

export const SILENCE_THRESHOLD = 5; // Audio level threshold
export const SILENCE_WARNING_DELAY = 30 * 1000; // 30 seconds
export const SILENCE_WARNING_COOL_DOWN = 60 * 1000; // 1 minute

export const MAX_SELECTED_APPROACHES = 3; // Maximum number of selected approaches

export const audioLevelMeterConfig = {
    default: {
        canvas: {
            width: 62, // width = bars.count * barWidth + bars.spacing * (bars.count - 1)
            height: 18,
        },
        bars: {
            count: 16,
            spacing: 2,
            borderRadius: 2,
        },
        colors: {
            active: 'fill-secondary',
            inactive: 'fill-input',
        },
        maxLevel: 255,
        smoothingFactor: 0.3,
        updateFps: 30,
    },
    recording: {
        canvas: {
            width: 180, // width = bars.count * barWidth + bars.spacing * (bars.count - 1)
            height: 18,
        },
        bars: {
            count: 16,
            spacing: 5,
            borderRadius: 4,
        },
        colors: {
            active: 'fill-secondary',
            inactive: 'fill-input',
        },
        maxLevel: 255,
        smoothingFactor: 0.3,
        updateFps: 30,
    },
} as const;

type GeneratorStepConfig = {
    key: GenerationStatus;
    label: string;
    progress: number;
};

export const generatorStepsConfig: GeneratorStepConfig[] = [
    { key: 'PREPARING_TRANSCRIPT', label: 'Read Transcript', progress: 0 },
    { key: 'DELETING_AUDIO', label: 'Delete audio', progress: 80 },
    { key: 'GENERATING_NOTE', label: 'Generate note', progress: 86 },
] as const;
